export class TaskActionQueryParams {
    taskId: string;
    action: string;
}